export const LOQATE_API_KEY = import.meta.env.VITE_LOQATE_API_KEY;
export const API_HOST = import.meta.env.VITE_API_HOST;
export const GOOGLE_MERCHANT_ID = import.meta.env.VITE_GOOGLE_MERCHANT_ID;
export const ORGANIZATION_NAME =
  import.meta.env.VITE_ORGANIZATION_NAME ?? "-- ORGANIZATION NAME --";
export const USE_QUERY_PARAM_ALIAS =
  import.meta.env.VITE_USE_QUERY_PARAM_ALIAS === "true";
export const USE_STATIC_CONFIG =
  import.meta.env.VITE_USE_STATIC_CONFIG === "true";
export const IS_DEVELOPMENT = import.meta.env.DEV;
export const IS_PRODUCTION = import.meta.env.PROD;
export const IS_TEST = import.meta.env.TEST;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_TRACE_TARGETS = API_HOST
  ? [new RegExp(`^${API_HOST.replace(/\./g, "\\.")}`)]
  : [];

export const ASSETS_PATH = window.__ASSETS_PATH__ || "/";
export const PAYMENT_ENVIRONMENT =
  import.meta.env.VITE_PAYMENT_ENVIRONMENT || "TEST";

export const CURRENCY = import.meta.env.VITE_CURRENCY_CODE || "GBP";
export const CURRENCY_LOCALE = import.meta.env.VITE_CURRENCY_LOCALE || "en-GB";
export const PAYMENT_ERROR_CODE = 2044;
// Longest wait for the payment-session replacement after a failed
// confirmation. Past it the donor sees the recovery banner instead of an
// endless processing spinner.
export const PAYMENT_SESSION_REPLACEMENT_TIMEOUT_MS = 15_000;
// Longest wait for /api/payment/confirm. Retrying on the same session is
// idempotent (the backend replays a stored result), so cutting a stalled
// request short costs nothing — leaving it open hangs the donor for as long
// as the proxy feels like. Confirms take 1–3 s in production; the margin
// covers a slow gateway call plus mail sending on a sync queue.
export const PAYMENT_CONFIRM_TIMEOUT_MS = 60_000;
// After a confirm with an unknown outcome the form asks the backend for the
// session status before showing the banner (#1153): one request every 2 s,
// each cut short after 5 s, and never past 30 s in total. A longer spinner
// invites a reload, which loses the session and can charge twice. The
// backend throttles this route at 30 requests a minute per IP.
export const CONFIRM_OUTCOME_POLL_INTERVAL_MS = 2_000;
export const CONFIRM_OUTCOME_REQUEST_TIMEOUT_MS = 5_000;
export const CONFIRM_OUTCOME_MAX_WAIT_MS = 30_000;
// Longest wait for a new Turnstile token when the one on hand is missing or
// expired at send time (tokens live 300 s; a 3DS challenge can take longer).
// Past it the confirm goes out without a token: the backend answers the same
// captcha 422 the donor would get today, instead of an endless spinner.
export const TURNSTILE_TOKEN_TIMEOUT_MS = 30_000;

export const TURNSTILE_SITE_KEY =
  import.meta.env.VITE_TURNSTILE_SITE_KEY || "1x00000000000000000000AA";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "";
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || "";

export const DONOR_PORTAL_URL = import.meta.env.VITE_DONOR_PORTAL_URL || "";
